module.exports = __webpack_public_path__ + "img/class-menu.f359f2cc.svg";